/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PatchAgentSkillPathParams = NonNullable<operations['patchAgentSkill']['parameters']['path']>;

export type PatchAgentSkillRequestBody = OperationRequestBodyContent<operations['patchAgentSkill']>;

export interface Input extends PatchAgentSkillPathParams {
  apiVersion?: string;
  body: PatchAgentSkillRequestBody;
}

export async function patchAgentSkill(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/api/v2/projects/{projectKey}/ai-configs/skills/{skillKey}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
